import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import {
  Alert,
  AlertDescription,
  AlertTitle,
  DateRange,
  FiltersDefinition,
  FiltersState,
  OneDataCollection,
} from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import DatasourceTypeRenderer from 'modules/ai_reports/components/DatasourceTypeRenderer'
import { ColumnFormatHint } from 'modules/ai_reports/components/DatasourceTypeRenderer/utils'
import { ReportSchemaType } from 'modules/ai_reports/lib/types'

import { ViewQuery } from './components/ViewQuery'

type ReportWidgetProps = {
  id: string
  dateFilter: DateRange | undefined
  tableId: string
  columnFormatHints: ColumnFormatHint[]
  reportName: string
  onStateChange?: React.ComponentProps<typeof OneDataCollection>['onStateChange']
  sqlQuery?: string
  description?: string
  hideMetadata?: boolean
  currentFilters?: FiltersState<FiltersDefinition<string>> | undefined
  schema: ReportSchemaType
  onSchemaChanged: (schema: ReportSchemaType) => void
}

export const ReportWidget = ({
  id,
  dateFilter,
  tableId,
  columnFormatHints,
  reportName,
  onStateChange,
  sqlQuery,
  description,
  hideMetadata = false,
  currentFilters,
  schema,
  onSchemaChanged,
}: ReportWidgetProps) => {
  const [userFacingSqlQuery, setUserFacingSqlQuery] = useState('')

  return (
    <>
      {!hideMetadata && (description || userFacingSqlQuery) && (
        <Box paddingX="s16">
          <Box paddingBottom="s16">
            <Alert>
              <AlertTitle>{i18n.t('ai_reports.reports.question_description')}</AlertTitle>
              <AlertDescription>
                <Box paddingBottom="s16">{description}</Box>
                {userFacingSqlQuery && <ViewQuery query={userFacingSqlQuery} />}
              </AlertDescription>
            </Alert>
          </Box>
        </Box>
      )}

      {sqlQuery && (
        <DatasourceTypeRenderer
          id={id}
          dateFilter={dateFilter}
          tableId={tableId}
          columnFormatHints={columnFormatHints}
          reportName={reportName}
          sqlQuery={sqlQuery}
          onStateChange={onStateChange}
          onUserFacingSqlQueryChange={setUserFacingSqlQuery}
          currentFilters={currentFilters}
          schema={schema}
          onSchemaChanged={onSchemaChanged}
        />
      )}
    </>
  )
}
